import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import { useParams } from 'react-router-dom';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import sections
import HeaderRegionLocation from 'js/containers/header-region/HeaderRegion.location';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import ContentItemCharactersGrid from 'js/components/content-item/ContentItem.characters-grid';

// import selectors
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';
import { getLocationByUrl } from '../store/locations/Locations.selectors';
import { getCharacterById } from 'js/store/characters/Characters.selectors';

import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';
import { BASE_API_URL } from '../constants/App';

import PageNotFound from 'js/page/Page.not_found';

const PageIndividualLocation = (props) => {
  const params = useParams();

  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.location]);
  });

  const location = useSelector((state) => {
    if (params.id) {
      return getLocationByUrl(state, params.id);
    }
    return null;
  });

  const linkedCharacters = useSelector((state) => {
    if (location && location?.characters) {
      return location.characters.map((obj) => getCharacterById(state, obj.id));
    }
  });

  const { name = '', previousItem = false, nextItem = false, also_spot_section = {} } = location;

  useEffect(() => {
    trackPageview({ title: name, path: props.path });
    window.fetch(`${BASE_API_URL}track_location/${location.id}`, {
      method: 'GET',
      headers: {
        'X-Language': window.siteData?.locale ?? 'en_GB',
      },
    });
  }, []);

  if (!location) {
    return <PageNotFound />;
  }

  // grab metadata for the character
  const { meta_title = '', meta_description = '', meta_meta_keywords = '' } = location || {};

  const metaData = {
    ...meta,
    title: meta_title !== null && meta_title !== '' ? meta_title : meta.title,
    description: meta_description !== null && meta_description !== '' ? meta_description : meta.description,
    keywords: meta_meta_keywords !== null && meta_meta_keywords !== '' ? meta_meta_keywords : meta.keywords,
  };

  return (
    <>
      <SiteMetaData {...metaData} />
      <HeaderRegionLocation data={location} name={name} previousItem={previousItem} nextItem={nextItem} />
      <div className="location-page__linked-characters">
        <SvgTextureLineLong color={'#efeffd'} />
        <div className="container">
          <h3>Familiar faces...</h3>
          <ContentItemCharactersGrid data={linkedCharacters} display_desc={true} />
        </div>
      </div>
      {/* <div className="location-page__spot">
        <SvgTextureLineLong color={'#2b5162'} />

        <div className="container">
          <h2>You might spot</h2>
          <div className="location-page__spot__content">
            <div className="location-page__spot__content__image">
              <img src={also_spot_section.also_spot_image} alt={also_spot_section.also_spot_name} />
            </div>
            <div className="location-page__spot__content__details">
              <h3>{also_spot_section.also_spot_name}</h3>
              <p>{also_spot_section.also_spot_description}</p>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default PageIndividualLocation;
